import { useStateContext } from "../contexts/ContextProvider";

const Button = ({ icon, bgColor, bgHoverColor, color, size, text, borderRadius}) => {
    const { setIsClicked, initialState } = useStateContext();
    return ( 
        <button
            type="button"
            onClick={() => setIsClicked(initialState)}
            style={{ backgroundColor: bgColor, color, borderRadius }}
            className={`text-${size} p-3 hover:dropshadow-xl hover:bg-${bgHoverColor}`}>
                {icon}{text}
        </button>
);
}
 
export default Button;